// extracted by mini-css-extract-plugin
export var anchorButtons = "styles-module--anchorButtons--51c5f";
export var button = "styles-module--button--44667";
export var buttonActive = "styles-module--buttonActive--2b613";
export var buttonText = "styles-module--buttonText--8f7b5";
export var buttonsContainer = "styles-module--buttonsContainer--2545c";
export var ctaText = "styles-module--ctaText--fcd84";
export var icon = "styles-module--icon--11ec9";